export default "__VITE_ASSET__CFozNu23__"